import { InjectionToken } from '@angular/core';

import { DeviceFingerPrint } from '@frontend/vanilla/core';

export const GridCardEventName = 'GridCard';
export const ConnectCardEventName = 'NfcIdCard';
export const ANONYMOUS_IDENTIFIER = 'anonymous';

export enum NFCCardType {
    GRID = 'GRID',
    CONNECT = 'CONNECT',
}

export const BETSTATION_LOGIN_ERROR = new InjectionToken<string>('BETSTATION_LOGIN_ERROR');
export const CARD_NUMBER = new InjectionToken<string>('CARD_NUMBER');
export const MESSAGE_DATA = new InjectionToken<MessageData>('MESSAGE_DATA');

export class MessageData {
    title: string;
    text: string;
    buttonText?: string;
}

export interface GridConnectLoginRequest {
    pin: string;
    connectCardNumber: string;
    loginType: string;
    loyaltyLoginEnabled: boolean;
    username?: string;
    password?: string;
    deviceFingerprint?: DeviceFingerPrint;
}
